import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { PageReactDataTable } from '@metarouter-private/mr-mui';

import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';

import buildPipelinesTableColumns from './buildPipelinesTableColumns';
import usePipelinesTable from './usePipelinesTable';
import PipelinesTableTitle from './PipelinesTableTitle';

export default function PipelinesTable({ onShowBulkPlaybookUpdate }) {
  const pipelinesTable = usePipelinesTable();
  const { pipelineTagsMvpEnabled } = useFeatureEnabled(FEATURE_FLAGS.pipelineTagsMvp);

  const columns = useMemo(
    () => buildPipelinesTableColumns({ showTags: pipelineTagsMvpEnabled }),
    [pipelineTagsMvpEnabled]
  );

  return (
    <PageReactDataTable
      columns={columns}
      title={<PipelinesTableTitle onShowBulkPlaybookUpdate={onShowBulkPlaybookUpdate} />}
      sortServer
      {...pipelinesTable}
    />
  );
}

PipelinesTable.propTypes = {
  onShowBulkPlaybookUpdate: PropTypes.func,
};

PipelinesTable.defaultProps = {
  onShowBulkPlaybookUpdate: null,
};
